import {ServiceFieldSettings} from "../ServiceFieldSettings";

/**
 * DuplicateFieldsConfiguration содержит настройки функционала дублирования
 * полей из родительских услуг и разделов.
 */
export class DuplicateFieldsConfiguration {
  /**
   * Fields содержит подключенные для дублирования в
   * колонке "Количество" поля и их настройки.
   */
  public Fields: { [T in string]: ServiceFieldSettings } = {}

  /**
   * Заглушка для запрета прямого создания объектов данного типа
   * @private
   */
  private constructor() {
  }

  /**
   * RestoreSettings выполняет восстановление данных объекта настроек
   * Функция выполняет нормализацию значений настроек.
   * Функция дополняет недостающие настройки значениями по умолчанию.
   *
   * @param data
   */
  public static RestoreSettings(data: any): DuplicateFieldsConfiguration {
    let result = new DuplicateFieldsConfiguration();

    if (typeof data === "string") {
      data = JSON.parse(data)
    }

    if (typeof data !== "object") {
      return result;
    }

    Object.keys(result).map((key: keyof DuplicateFieldsConfiguration) => {
      // @ts-ignore
      result[key] = DuplicateFieldsConfiguration.GetCorrectFieldValue(key, data[key])
    })

    return result;
  }

  /**
   * GetCorrectFieldValue выполняет восстановление данных поля из переданного значения настроек.
   * Данный метод так же проводит валидацию значения каждой из настроек поля. Метод возвращает
   * значение по умолчанию, если значение передано не корректно.
   */
  public static GetCorrectFieldValue<T extends keyof DuplicateFieldsConfiguration>(field: T, data: any): any {
    let defaults = new DuplicateFieldsConfiguration()

    if (data === undefined) {
      return defaults[field]
    }

    switch (field) {
      case "Fields":
        if (typeof data !== "object") {
          return {}
        }

        const result: { [T in string]: ServiceFieldSettings } = {}
        Object.keys(data).map(k => {
          result[k] = ServiceFieldSettings.RestoreSettings(data[k])
        })

        return result
    }

    return defaults[field];
  }
}